import React, { useEffect, useState } from "react";
import { Bookmark, BorderOuter, ContentCopy, CropOriginal, DateRange, Favorite, FmdBad, Fullscreen, GeneratingTokens, GTranslate, Lock, Login, Public, RemoveRedEye, SafetyCheck, SmartToy, Star } from "@mui/icons-material";
import { Link, useParams } from "react-router-dom";
import { formatCreatedAt, formatFollowers, getOptimizedImage, handleCopy, supportMessage } from "../utils/Universalfunctions";
import SEO from "../config/SEO";
import { shortLogo } from "../config/config";
import { db } from "../utils/firebase";
import { collection, doc, getDocs, increment, onSnapshot, updateDoc } from "firebase/firestore";
import FollowersSystem from "./FollowersSystem";
import toasted from "../config/toasted";
import InnerPromptMedia from "../componets/InnerPromptMedia";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useUser } from "../context/UserContext";
import Bookmarks from "../componets/Promptcards/Bookmarks";
import LikeButton from "../componets/LikeButton";
import { inShareUniversal } from "../utils/DynamicUniversalFunctions";

const PromptsInfo = () => {

      // Get prompt ID from URL parameters
      const { id } = useParams();
      const { user, userData, isPremium } = useUser();


      const [view, setView] = useState(false);
      const [prompts, setPrompts] = useState([]);


      // Fetch prompt details from Firestore based on ID
      useEffect(() => {

            if (!id) {
                  toasted.error("Invalid prompt id");
                  return;
            }

            const fetchPrompts = async () => {
                  try {

                        const querySnapshot = await getDocs(collection(db, "prompts"));
                        const list = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

                        const found = list.find(item => item.id === id);
                        setPrompts(found || null);

                  } catch (err) {
                        toasted.error("Error fetching prompts:", err);
                  } finally {
                        // setLoading(false);
                  }
            };


            fetchPrompts();

      }, [id]);



      useEffect(() => {
            if (!id) return;

            const increaseView = async () => {

                  try {
                        await updateDoc(doc(db, "prompts", id), {
                              view: increment(1)
                        });

                  } catch (error) {
                        console.error("View error:", error);
                  }
            };

            increaseView();

      }, [id]);



      const openChatGPT = () => {
            alert(
                  "✅ Prompt copied to clipboard!\n\n" +
                  "Next Steps:\n" +
                  "1. ChatGPT will open in a new tab.\n" +
                  "2. Click the '+' icon to upload a CLEAR PICTURE & FACE."
            );

            const url = `https://chat.openai.com/?q=${encodeURIComponent(`${prompts?.promptText} important Don't change the face Keep it 100% as it is`)}`;
            window.open(url, "_blank");
      };

      const openGemini = () => {
            const promptText = `${prompts?.promptText} important Don't change the face Keep it 100% as it is` || "Hello Gemini! Prompt Not Copy Please try again";

            navigator.clipboard.writeText(promptText).then(() => {
                  alert(
                        "✅ Prompt copied to clipboard!\n\n" +
                        "Next Steps:\n" +
                        "1. Gemini will open in a new tab.\n" +
                        "2. Paste (Ctrl+V) your prompt.\n" +
                        "3. Click the '+' icon to upload a CLEAR PICTURE & FACE."
                  );


                  window.open('https://gemini.google.com/app', '_blank');
            }).catch(err => {
                  console.error('Copy failed', err);
            });
      };

      const getImageSrc = (prompt) => {
            // New prompts (Cloudinary)
            if (prompt) {
                  return getOptimizedImage({
                        publicId: prompt,
                        width: 1200,
                        watermark: true,
                  });
            }

            // Old prompts (imgbb fallback)
            return prompt; // imgbb URL
      };


      const renderTooltip = (text) => (
            <Tooltip id={`tooltip-${text.replace(/\s+/g, '-').toLowerCase()}`}>
                  {text}
            </Tooltip>
      );



      const [realData, setRealData] = useState({
            like: "",
            view: '',
            bookmark: '',
            share: ''

      })


      useEffect(() => {
            if (!id) return;

            const ref = doc(db, "prompts", id);

            const unsubscribe = onSnapshot(ref, (snap) => {
                  if (snap.exists()) {
                        const data = snap.data();
                        setRealData({
                              likes: data.likes,
                              view: data.view,
                              bookmark: data.bookmarks,
                              share: data.share,
                        })

                  }
            });

            return () => unsubscribe();
      }, [id]);


      console.log(prompts)

      return (
            <>

                  <SEO
                        title={`${prompts?.title} - AI Prompt`}
                        description={"Discover and copy powerful AI prompts for ChatGPT, Gemini and other AI tools on HeyPrompt."}
                        keywords={`${prompts?.title}, ai prompts, chatgpt prompts, gemini prompts, prompt engineering`}
                        canonicalPath={`/prompts/${id}`}
                  />


                  <div className="prompt-info">
                        <div className="__container">
                              <div className="row align-items-start">

                                    {prompts?.length === 0 ?
                                          <div className="col-12">
                                                <div className="support-box">
                                                      <h4 className="__title">Enjoying HeyPrompt?</h4>
                                                      <p>Your support helps us continue to provide free, high-quality AI prompts. Consider supporting us!</p>
                                                      <Link to="https://www.instagram.com/heyprompt.online/" target="_blank" className="btn">Support HeyPrompt</Link>
                                                </div>
                                          </div>
                                          :

                                          <>
                                                <div className="col-md-5 start-sticky-top-jsk3">
                                                      <div className="image-box">
                                                            {prompts?.visibility === 'private' &&
                                                                  <p className="premium-badge premium-icon">
                                                                        <span className="icon"> <Star /> </span>
                                                                        <span className="text">Premium</span>
                                                                  </p>
                                                            }
                                                            <img
                                                                  src={getImageSrc(prompts?.imageUrl)}
                                                                  alt={prompts?.title || "Prompt Image & Artwork"}
                                                                  className="img-fluid"
                                                            />

                                                            <button type="button" onClick={() => setView(true)} className="btn full-screen-button">
                                                                  <Fullscreen />
                                                            </button>
                                                      </div>
                                                </div>

                                                <div className="col-md-7">
                                                      <div className="info-box">

                                                            <h2 className="title">{prompts?.title || 'Prompt Title'}</h2>
                                                            <p className="category">category:        {prompts?.category}</p>

                                                            <div className="prompt-info-col">
                                                                  <div className="row row-gap-3">
                                                                        <div className="col-12">
                                                                              <h5>Generation Details</h5>
                                                                              <div className="prompt-scroll">
                                                                                    <div className="prompt-info-col-in">

                                                                                    <OverlayTrigger placement="top" overlay={renderTooltip("Total Views")}>
                                                                                          <p className="info-item"> <RemoveRedEye />{formatFollowers(realData?.view || realData?.likes) || 0}</p>
                                                                                    </OverlayTrigger>

                                                                                    <OverlayTrigger placement="top" overlay={renderTooltip("Total bookmarks")}>
                                                                                          <p className="info-item"> <Bookmark />{realData?.bookmark ? formatFollowers(realData?.bookmark) : 0 || 0}</p>
                                                                                    </OverlayTrigger>

                                                                                    <OverlayTrigger placement="top" overlay={renderTooltip("AI Model Used")}>
                                                                                          <p className="info-item "> <SmartToy /> {prompts?.aiModel || 'AI Name'}</p>
                                                                                    </OverlayTrigger>

                                                                                    <OverlayTrigger placement="top" overlay={renderTooltip("Resolution")}>
                                                                                          <p className="info-item "> <BorderOuter /> 1024x1536 </p>
                                                                                    </OverlayTrigger>

                                                                                    <OverlayTrigger placement="top" overlay={renderTooltip("Published Date")}>
                                                                                          <p className="info-item "> <DateRange /> {formatCreatedAt(prompts?.createdAt) || 'N/A'}</p>
                                                                                    </OverlayTrigger>
                                                                              </div>
                                                                              </div>
                                                                        </div>

                                                                        <div className="col-12">
                                                                              <h5>Prompt Security</h5>
                                                                              <div className="prompt-info-col-in">
                                                                                    <OverlayTrigger placement="top" overlay={renderTooltip("Prompt Status")}>
                                                                                          <p className={`info-item ${prompts?.visibility === 'private' ? 'v2-desin' : ''}`}> <Public /> {prompts?.visibility === 'public' ? 'Free' : "Premium" || 'Public'}</p>
                                                                                    </OverlayTrigger>

                                                                                    <OverlayTrigger placement="top" overlay={renderTooltip("Content Safety Rating")}>
                                                                                          <p className="info-item "> <SafetyCheck /> {prompts?.contentRating || 'Everyone'}</p>
                                                                                    </OverlayTrigger>

                                                                                    <OverlayTrigger placement="top" overlay={renderTooltip("Source of Prompt")}>
                                                                                          <p className="info-item "><CropOriginal /> {prompts?.promptSource || 'Original'}</p>
                                                                                    </OverlayTrigger>

                                                                                    <OverlayTrigger placement="top" overlay={renderTooltip("Language")}>
                                                                                          <p className="info-item "> <GTranslate /> English</p>
                                                                                    </OverlayTrigger>

                                                                              </div>
                                                                        </div>
                                                                  </div>
                                                            </div>

                                                            <div className="artist-row row align-items-center">
                                                                  <div className="col-12">
                                                                        <div className="artist-info">
                                                                              <div className="artist-info-details">
                                                                                    <img
                                                                                          src={`https://api.dicebear.com/7.x/avataaars/svg?seed=user${prompts?.username || 'anonymous'}&gender=male`}
                                                                                          alt="Artist"
                                                                                          className="artist-img"
                                                                                    />
                                                                                    <div>
                                                                                          <p className="artist-name">
                                                                                                {/* @{userData?.name ? userData?.name : prompts?.username || "Anonymous"} */}
                                                                                                #{prompts?.username ? prompts?.username : prompts?.username || "Anonymous"}
                                                                                          </p>
                                                                                          <span className="likes">
                                                                                                <Favorite fontSize="small" /> {realData?.likes || 0} likes
                                                                                          </span>
                                                                                    </div>
                                                                              </div>

                                                                              <div className="action-artist">
                                                                                    {prompts?.userId === "ADMIN" ?
                                                                                          <span className="badge bg-danger">{`access denied`.toLocaleUpperCase()}</span>
                                                                                          :
                                                                                          <>
                                                                                                {user && (
                                                                                                      <FollowersSystem
                                                                                                            currentUserUID={user?.uid}
                                                                                                            profileUserUID={prompts?.userUID || prompts?.userId}
                                                                                                      />
                                                                                                )}
                                                                                                {!user &&
                                                                                                      <Link to="/login" className="btn btn-follow"><Login className="me-1" /> Login</Link>
                                                                                                }
                                                                                          </>
                                                                                    }
                                                                              </div>
                                                                        </div>
                                                                  </div>
                                                            </div>





                                                            <div className="prompt-section">

                                                                  {prompts?.visibility === "public" || isPremium ? (
                                                                        <>
                                                                              <div className="prompt-box">
                                                                                    <label>Your Prompt</label>

                                                                                    <div className="prompt-hj3n">
                                                                                          {user ? prompts?.promptText :
                                                                                                <div className="divider-login">
                                                                                                      Please log in to view prompts. <br /> To access all features and see prompts properly, please log in now.

                                                                                                      {!user &&
                                                                                                            <div className="alert alert-info mt-2 mb-0" role="alert">
                                                                                                                  <FmdBad className="me-1" /> Please <Link to="/login">login</Link> to follow creators and access more features.
                                                                                                            </div>
                                                                                                      }
                                                                                                </div>
                                                                                          }
                                                                                    </div>

                                                                                    {user &&
                                                                                          <div className="prompt-generate-action">

                                                                                                {prompts?.ai_name === 'ChatGPT' ?
                                                                                                      <button className="btn try-btn" onClick={openChatGPT}> <GeneratingTokens fontSize="small"/> Try This</button>
                                                                                                      :
                                                                                                      <button className="btn try-btn" onClick={openGemini}> <GeneratingTokens fontSize="small"/> Try This</button>}
                                                                                                <button className="btn btn-share"
                                                                                                      onClick={() =>
                                                                                                            handleCopy(`${prompts?.promptText} ${supportMessage}`)
                                                                                                      } >
                                                                                                      <ContentCopy fontSize="small" /> Copy
                                                                                                </button>
                                                                                          </div>
                                                                                    }
                                                                              </div>

                                                                              <div className="actions">
                                                                                    <h5>actions </h5>

                                                                                    <div className="ac-list">
                                                                                          <div className="items-acl">
                                                                                                <p>{realData?.bookmark ? formatFollowers(realData?.bookmark) : 0 || 0} </p>
                                                                                                <Bookmarks
                                                                                                      userData={userData}
                                                                                                      visibleData={prompts}
                                                                                                />
                                                                                          </div>

                                                                                          <div className="items-acl">
                                                                                                <p>{formatFollowers(realData?.likes) || 0} </p>
                                                                                                <LikeButton card={prompts} />
                                                                                          </div>

                                                                                          <div className="items-acl">
                                                                                                <p>{realData?.share ? formatFollowers(realData?.share) : 0 || 0} </p>
                                                                                                <button className="btn btn-share"
                                                                                                      onClick={() => inShareUniversal(`${window.location.origin}/prompts/${prompts?.id}`, userData, prompts?.id)} >Share</button>
                                                                                          </div>

                                                                                    </div>
                                                                              </div>



                                                                        </>
                                                                  ) : (
                                                                        <div className="primium-item">
                                                                              <p><Lock /></p>

                                                                              <div className="pi-inner">
                                                                                    <h5>Premium Content</h5>
                                                                                    <p>
                                                                                          This prompt is exclusive to subscribers.
                                                                                          Subscribe to any plan to unlock all premium prompts
                                                                                          and access the Studio.
                                                                                    </p>

                                                                                    {user ? (
                                                                                          <Link to="/pricing" className="btn unlock-btn">View subscription plans</Link>
                                                                                    ) : (
                                                                                          <Link to="/login" className="btn unlock-btn"> Upgrade & Login Now</Link>
                                                                                    )}
                                                                              </div>
                                                                        </div>
                                                                  )}


                                                            </div>



                                                            <div className="usage-instructions">
                                                                  <InnerPromptMedia prompts={prompts} />


                                                                  <h4 className="__title">How to Use This Prompt</h4>
                                                                  <ol>
                                                                        <li>Copy the prompt using the "Copy" button.</li>
                                                                        <li>Paste it into your preferred AI tool or platform.</li>
                                                                        <li>Customize any parameters as needed for your specific use case.</li>
                                                                        <li>Run the prompt and review the generated output.</li>
                                                                        <li>Make adjustments and iterate as necessary to achieve desired results.</li>
                                                                  </ol>
                                                            </div>
                                                      </div>
                                                </div>
                                          </>

                                    }

                              </div>



                        </div>
                  </div>


                  {view && (
                        <div className="fullView" onClick={() => setView(false)}>
                              <img src={getImageSrc(prompts?.imageUrl) || shortLogo} alt="Prompt Artwork full view" />
                        </div>
                  )}

            </>

      );
};

export default PromptsInfo;
